export default "/images/b6107ff96e709c416af1a4a2b68e0783.avif";